// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"88f44db3","453":"5fc936c6","967":"06d46978"}[chunkId] + ".chunk.js";
};